import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { SharedModule } from '@shared/shared.module';
import { SpreadSheetsModule } from '@grapecity/spread-sheets-angular';
// import { AssumptionsService } from '@services/assumptions/assumptions.service';
import { AssumptionsComponent } from './assumptions/assumptions.component';

const routes: Routes = [];

@NgModule({
  imports: [CommonModule, SharedModule, RouterModule.forChild(routes), SpreadSheetsModule],
  declarations: [AssumptionsComponent],
  exports: [RouterModule],
})
export class AssumptionsModule {}
